import { Component } from "@angular/core";
import { WorkFlowCreatorNodeType } from "../../webhook-types/workflow-creator-node-type";
import { ToolBoxModel } from "../../webhook-interfaces/toolbox";


@Component({
    selector: 'webhook-toolbox',
    templateUrl: './webhook-edit-toolbox.component.html',
    styleUrl: './webhook-edit-toolbox.component.scss',
    standalone: false
})
export class WebhookEditToolboxComponent {

    closed = false;
    draggable = false;
    showMore = false;
    ctrol = 0;
    mouse = 0;
    index: number = 0;
    maxHeight: number = 0;

    constructor() {
        this.maxHeight = window.innerHeight - 120;
    }
    
    // a flag active da preferencia agora vale de fato: e como o administrador
    // esconde da paleta um artefato ainda sem layout cadastrado
    artefacts:ToolBoxModel[]= this.lerToolBox('flow.toolbox.artefacts');
    connectors: ToolBoxModel[] = this.lerToolBox('flow.toolbox.connector');

    private lerToolBox(preferencia:string): ToolBoxModel[] {
        let itens = JSON.parse(localStorage.getItem(preferencia)) as ToolBoxModel[];
        if ( itens == null ){
            return [];
        }
        return itens.filter(item=>item.active != false);
    }
    


    public mouseDown(event: MouseEvent): void { 
        event.preventDefault();
        this.mouse = 1;
        if ( this.mouse == 1){
          this.draggable = true;
        }else{
          this.draggable = false;
        }
      }
    
      public mouseUp(event: MouseEvent): void { 
        event.preventDefault();
        this.mouse = 0;
        this.draggable = false;
      }
    
      close(){
        this.closed = !this.closed;
        if (this.closed) {
            this.showMore = false;
        }
      }
}